export default "__VITE_ASSET__jBL9wbBR__"